import { Flex, Modal } from 'antd';
import styled from 'styled-components';

export const ModalWrapper = styled(Modal)`
  max-width: 320px;

  .ant-rate {
    font-size: 40px;
    color: ${({ theme }) => theme.colors.green6};
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    max-width: 400px;
  }
`;

export const Wrapper = styled(Flex)`
  padding: 24px 0;
`;

export const TitleWrapper = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  flex: 1 0 0;
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  text-overflow: ellipsis;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.2px;
`;

export const RateDescriptionWrapper = styled.span`
  color: ${({ theme }) => theme.colors.black6};
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const SecondaryTitleWrapper = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;
